import PropTypes from "prop-types";
import { Input } from "@vds/inputs";
import { ModalBody, ModalFooter, ModalTitle } from "@vds/modals";
import { Body, Title } from "@vds/typography";
import { Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../../store/actions/asset";
import { getLocationZoneList } from "../../common/utils/utils";

function CreateAssetStep3(props) {
  const { formData, onExit } = props;
  const dispatch = useDispatch();
  const { locations } = useSelector((state) => ({
    locations: state.asset.data.uniqueLocations || [],
  }));
  const handleNext = () => {
    dispatch(updateUI({ formData: { ...formData, selectedStep: 4 } }));
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;

    dispatch(
      updateUI({
        formData: { ...formData, step3: { ...formData.step3, [name]: value } },
      })
    );
  };

  const handleLocationZoneFieldChange = (key, name, value, locationObj) => {
    if (!locationObj) {
      dispatch(
        updateUI({
          formData: {
            ...formData,
            step3: {
              ...formData.step3,
              [name]: "",
              location: null,
            },
          },
        })
      );
      return;
    }
    const [_, floorId, zoneId] = key.split("=");
    const floor = locationObj?.floors?.find((f) => f.id === floorId);
    if (!floor) {
      console.error("Floor not found for ID:", floorId);
      return;
    }
    const zone = floor?.zones?.find((z) => z.id === zoneId);
    if (!zone) {
      console.error("Zone not found for ID:", zoneId);
      return;
    }
    delete floor.zones;
    let locationObjWithZone = {
      ...locationObj,
      floor: { ...floor, zone: zone },
    };
    delete locationObjWithZone.floors;
    dispatch(
      updateUI({
        formData: {
          ...formData,
          step3: {
            ...formData.step3,
            [name]: value,
            location: locationObjWithZone,
          },
        },
      })
    );
  };

  return (
    <>
      <ModalTitle>
        <Body size="large">Add asset</Body>
        <div className="mt-2">
          <Title size="large" bold={true}>
            Additional details
          </Title>
        </div>
      </ModalTitle>
      <ModalBody>
        <div className="d-flex flex-column justify-content-start align-items-start mb-4">
          <div className="d-flex flex-row justify-content-start align-items-center gap-1">
            <Body size="small">Location zone</Body>
            <Body size="small" color="#6F7171">
              Optional
            </Body>
          </div>
          <Select
            className="shipment-form-fields"
            style={{
              marginTop: "8px",
            }}
            defaultValue={formData?.step3?.locationZone}
            options={[
              {
                key: "empty-location-zone",
                label: "No location zone",
                value: "",
                locationObj: null,
              },
              ...getLocationZoneList(locations).map((location) => ({
                key: location.id,
                label: location.name,
                value: location.name,
                locationObj: location.location,
              })),
            ]}
            onChange={(value, option) => {
              handleLocationZoneFieldChange(
                option.key,
                "locationZone",
                value,
                option.locationObj
              );
            }}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center gap-4 mb-4">
          <Input
            type="text"
            label="Asset type"
            name="assetType"
            defaultValue={formData?.step3?.assetType}
            readOnly={false}
            required={false}
            disabled={false}
            error={false}
            errorText="Enter a valid asset type."
            onChange={handleFieldChange}
          />
          <Input
            type="text"
            label="Asset model"
            name="assetModel"
            defaultValue={formData?.step3?.assetModel}
            readOnly={false}
            required={false}
            disabled={false}
            error={false}
            errorText="Enter a valid asset model."
            onChange={handleFieldChange}
          />
        </div>
        <div className="d-flex justify-content-center align-items-center gap-4">
          <Input
            type="text"
            label="Asset serial number"
            name="assetSerialNumber"
            defaultValue={formData?.step3?.assetSerialNumber}
            readOnly={false}
            required={false}
            disabled={false}
            error={false}
            errorText="Enter a valid asset serial number."
            onChange={handleFieldChange}
          />
          <Input
            type="text"
            label="Asset owner"
            name="assetOwner"
            defaultValue={formData?.step3?.assetOwner}
            readOnly={false}
            required={false}
            disabled={false}
            error={false}
            errorText="Enter a valid asset owner."
            onChange={handleFieldChange}
          />
        </div>
      </ModalBody>
      <ModalFooter
        buttonData={{
          close: {
            width: "100%",
            children: "Next",
            onClick: handleNext,
          },
          primary: {
            children: "Back",
            width: "100%",
            onClick: onExit,
          },
        }}
      />
    </>
  );
}

CreateAssetStep3.propTypes = {
  formData: PropTypes.object.isRequired,
  onExit: PropTypes.func.isRequired,
};

export default CreateAssetStep3;
